import React from "react";

export default function CarrerHeader(props: any) {
  return (
    <div className="container">
      {props.children}
    </div>
  );
}
